import './FilterWrapper.scss'

import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { COUNTRY_COLORS } from '../../constants/country-color'
import { Empresas } from '../../constants/empresas'
import { Proyectos } from '../../constants/proyectos'
import { IProyectos } from '../../data/data.model'
import { Filters } from '../Filters/Filters'
import { ProjectHexagon } from '../FilterTable/components/ProjectHexagon'
import { FilterTable } from '../FilterTable/FilterTable'
import { SectionHeader } from '../SectionHeader/SectionHeader'

export const FilterWrapper = () => {
  const { t }: any = useTranslation()
  const [isMobile, setIsMobile] = useState(
    window.matchMedia('(max-width: 768px)').matches
  )
  const [proyectosData, setProyectosData] = useState<IProyectos[]>([])

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)')
    const handleChange = (e: any) => setIsMobile(e.matches)

    mediaQuery.addEventListener('change', handleChange)

    if (Proyectos.length > 0 && Empresas.length > 0) {
      const proyectosEmpresas = Proyectos.map((proyecto: IProyectos) => {
        const empresas: string[] = []
        proyecto.company_intern_id.forEach((id_empresa: string) => {
          const empresa = Empresas.find(
            (empresa) => empresa.intern_id === id_empresa
          )
          if (empresa) {
            empresas.push(empresa.company_name)
          }
        })

        return {
          ...proyecto,
          empresas,
        }
      })

      setProyectosData(proyectosEmpresas)
    }
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [])

  return (
    <div className="project-filters">
      <Filters data={proyectosData}></Filters>
      <FilterTable data={proyectosData}></FilterTable>
    </div>
  )
}
